export const ELDMReportFilters = [
    {
        displayName: "Overall - Type of Loss - by Category 1", value: "Overall - Type of Loss - by Category 1", reportParam: "Category1"
    },
    {
        displayName: "Overall - Type of Loss - by Category 2", value: "Overall - Type of Loss - by Category 2", reportParam: "Category2"
    },
    {
        displayName: "Overall - Type of Loss - by Category 3", value: "Overall - Type of Loss - by Category 3", reportParam: "Category3"
    },
    // {
    //     displayName: "OEE Actual List", value: "OEE - Full List by Year - OEE Actual", reportParam: null
    // },
    {
        displayName: "UP/DOWN/POWER by Total", value: "WILLIS ENERGY LOSS DATABASE -  Analysis by UP/DOWN/POWER - Actual", reportParam: "UpDownPower"
    },
    {
        displayName: "Overall Losses – by Year", value: "Overall Losses– by Year", reportParam: "Year"
    },
    {
        displayName: "Overall Losses – by Area", value: "Overall Losses– by Area", reportParam: "Area"
    },
    {
        displayName: "Overall Losses – by Country", value: "Overall Losses– by Country", reportParam: "Country"
    },
    {
        displayName: "Overall Losses – by Location", value: "Overall Losses– by Location", reportParam: "Location"
    },
    {
        displayName: "Overall Losses – WELD Report", value: "Overall Losses– WELD Report", reportParam: "WELD"
    },
    {
        displayName: "OEE Info Report", value: "Overall Losses– by OEEActual", reportParam: "OEEActual"
    }
];


// WEBPACK FOOTER //
// ./src/app/modules/el-data-management/eldm-report-filters.const.ts